import { _ep0, _mw0, command } from "../commandBuilder";
import { DeleteChurch$ } from "../schemas/schemas_0";
export class DeleteChurchCommand extends command(_ep0, _mw0, "DeleteChurch", DeleteChurch$) {
}
